import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment } from 'react';
import EntityTypes from '../../types/EntityTypes';
import { PlaceholderIcon } from '../../components/Icons';
import renderInlines from '../utils/renderInlines';
import { normalizeNode, shouldHaveText } from '../utils/NormalizationHelper';
import makeToolbarButton, { EXPANDED_SELECTION } from '../utils/makeToolbarButton';
import DocumentEventListener from '../../components/DocumentEventListener';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import createStore from '../utils/createStore';
import onKeyDown from './handlers/onKeyDown';
import onChange from './handlers/onChange';
import onPaste from './handlers/onPaste';
import Placeholder from './PlaceholderComponent';
import './style.css';
export function placeholderInSelection(editor, store) {
  var focusInline = editor.value.focusInline;

  if (!focusInline || focusInline.type !== EntityTypes.PLACEHOLDER) {
    return null;
  }

  var inlineStore = store.getItem(focusInline.key);
  return inlineStore && _objectSpread({}, inlineStore, {
    key: focusInline.key
  });
}
export function deleteAndSetMarks(editor, key) {
  var placeholderNode = editor.value.document.getNode(key);
  editor.removeNodeByKey(key);
  placeholderNode.getMarks().map(editor.addMark);
}
export default (function () {
  var store = createStore({
    isForward: null,
    mouseDown: false
  });

  function onMouseDown() {
    store.updateItem('mouseDown', true);
    store.updateItem('isForward', null);
  }

  function onMouseUp() {
    store.updateItem('mouseDown', false);
  }

  return [_objectSpread({
    commands: {
      addPlaceholder: function addPlaceholder(editor) {
        var selection = editor.value.selection;
        if (!selection.isExpanded) return;
        editor.unwrapInline().wrapInline({
          type: EntityTypes.PLACEHOLDER
        }); // If the focus was at the beginning of the next line, we now have a null block in our path
        // So we move the focus back to the end of the previous block

        if (selection.end.offset === 0) {
          editor.moveFocusToEndOfPreviousText();
        }
      },
      removePlaceholder: function removePlaceholder(editor, key) {
        store.updateItem(key, null);
      },
      selectPlaceholder: function selectPlaceholder(editor, _ref) {
        var key = _ref.key,
            edition = _ref.edition;
        editor.command('deselectPlaceholder');
        store.updateItem(key, {
          selected: true,
          edition: edition
        });
        store.updateItem('selectedPlaceholder', key);
        return editor.command('deactivateToolbar');
      },
      deselectPlaceholder: function deselectPlaceholder(editor) {
        var selectedPlaceholder = store.getItem('selectedPlaceholder');

        if (selectedPlaceholder) {
          store.updateItem(selectedPlaceholder, {
            edition: false,
            selected: false
          });
          store.updateItem('selectedPlaceholder', false);
        }

        return editor.command('activateToolbar');
      }
    }
  }, onKeyDown({
    store: store
  }), {}, onChange({
    store: store
  }), {}, onPaste({
    store: store
  }), {
    onCommand: function onCommand(command, editor, next) {
      if (command.type !== 'activateToolbar' || !store.getItem('selectedPlaceholder')) {
        next();
      }
    },
    onBlur: function onBlur(event, editor, next) {
      editor.command('deselectPlaceholder');
      next();
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Fragment, null, next(), React.createElement(DocumentEventListener, {
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown
      }));
    }
  }), normalizeNode(EntityTypes.PLACEHOLDER, [shouldHaveText]), renderInlines(_defineProperty({}, EntityTypes.PLACEHOLDER, function (props, editor, next) {
    return React.createElement(Placeholder, Object.assign({
      store: store
    }, props, props.attributes));
  })), makeToolbarButton(EntityTypes.PLACEHOLDER, {
    icon: PlaceholderIcon,
    title: 'Placeholder',
    visibility: EXPANDED_SELECTION,
    isActive: function isActive(editor) {
      return editor.isActiveInline(EntityTypes.PLACEHOLDER);
    },
    onApply: function onApply(editor) {
      editor.isActiveInline(EntityTypes.PLACEHOLDER) ? editor.unwrapInline() : editor.command('addPlaceholder');
    }
  }), makeKeyboardCommandShortcut('mod+alt+p', {
    type: EntityTypes.PLACEHOLDER,
    canApply: function canApply(editor) {
      return editor.value.selection.isExpanded;
    },
    command: function command(editor) {
      return editor.isActiveInline(EntityTypes.PLACEHOLDER) ? editor.unwrapInline() : editor.command('addPlaceholder');
    },
    byKey: false
  })];
});